module.exports = __webpack_public_path__ + "static/img/1404.016f48a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/1404.png
// module id = 5evJ
// module chunks = 0